// extracted by mini-css-extract-plugin
var _1 = "ymc5Q";
var _2 = "kTlOG";
var _3 = "N4jUU";
var _4 = "IbEh7";
var _5 = "ICfnz";
var _6 = "mM85t";
var _7 = "hGP5p";
var _8 = "aSGde";
export { _1 as "addNewColumnCell", _2 as "base", _3 as "cell", _4 as "columnHeader", _5 as "columnName", _6 as "empty", _7 as "isColumnSelected", _8 as "rowHeader" }
